// Libraries
import { action, computed } from "mobx";

// Core
import { FieldType } from "Core/Utils/Utils";
import { ViewModelBase } from "Core/ViewModels/ViewModelBase";

// Custom
import { AccountStore } from "Custom/Stores/Domain";
import { StoresInstance } from "Core/Base";
import { Seamsil100Model } from "Custom/Models/Domain/ProductSelector/SubModels/RoofSystemSubModels/SeamsilProductModels/Seamsil100";

export class Seamsil100ViewModel extends ViewModelBase<Seamsil100Model> {
    private accountStore: AccountStore = StoresInstance.domain.AccountStore;
    constructor(model: Seamsil100Model) {
        super(model);
        this.setDecorators(Seamsil100Model);
    }

    // #region Product Properties

    @computed
    public get endlapMeterage(): number {
        return this.model.endlapMeterage;
    }

    @computed
    public get overlapMeterage(): number {
        return this.model.overlapMeterage;
    }

    @computed
    public get colours(): any[] {
        return this.model.colours;
    }

    @computed
    public get ridgeFlashingsEtcMeterage(): number {
        return this.model.ridgeFlashingsEtcMeterage;
    }

    @computed
    public get profileCorrectionPercentage(): number {
        return this.model.profileCorrectionPercentage;
    }

    @computed
    public get topcoatColourSelection(): any {
        return this.model.topcoatColourSelection;
    }

    @computed
    public get colourValidationMessage(): string {
        const result = this.validateDecorators("topcoatColourSelection");
        return !this.accountStore.HasSubmitted === true ? "" : result.isValid ? "" : result.errorMessage;
    }

    @action
    public setEndlapMeterage = (value: number): void => {
        this.model.endlapMeterage = value;
    };

    @action
    public setOverlapMeterage = (value: number): void => {
        this.model.overlapMeterage = value;
    };

    @action
    public setProfileCorrectionPercentage = (value: number): void => {
        this.model.profileCorrectionPercentage = value;
    };

    @action
    public setRidgeFlashingsEtcMeterage = (value: number): void => {
        this.model.ridgeFlashingsEtcMeterage = value;
    };

    @action
    public setTopcoatColour = (selection: any): void => {
        this.model.topcoatColourSelection = selection;
    };

    // #endregion Product Properties

    // #region Viewmodel Boilerplate

    public afterUpdate: undefined;
    public beforeUpdate: undefined;

    public isFieldValid(fieldName: keyof FieldType<Seamsil100Model>): boolean {
        return true;
    }

    // #endregion Viewmodel Boilerplate
}
